import { useCallback, useState } from 'react';

import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import PageSection from '@sayyesschool/frontend/components/page-section';
import { useMeetings } from '@sayyesschool/frontend/features/meetings';
import { Tabs } from '@sayyesschool/frontend/ui-components';

import MeetingRegistrationForm from '@/components/meetings/meeting-registration-form';
import MeetingsList from '@/components/meetings/meetings-list';

function LearnerMeetingsView({ learner, meetings, onCreate, onUpdate, onDelete }) {
    const [view, setView] = useState('scheduled');
    const [meeting, setMeeting] = useState(null);

    const handleSubmit = useCallback(data => {
        onCreate(meeting, data)?.finally(() => setMeeting(null));
    }, [meeting, onCreate]);

    const handleTabChange = useCallback((event, value) => {
        setView(value);
    }, []);

    const scheduledMeetings = meetings?.filter(m => m.isScheduled === true);
    const pastMeetings = meetings?.filter(m =>
        m.isEnded === true &&
        m.registrations?.some(r => r.userId === learner.id));

    return (
        <PageSection
            className="LearnerMeetings"
            title="Разговорный клуб"
            header={
                <Tabs
                    value={view}
                    items={[
                        {
                            key: 'scheduled',
                            value: 'scheduled',
                            content: 'Предстоящие'
                        },
                        {
                            key: 'past',
                            value: 'past',
                            content: 'Прошедшие'
                        }
                    ]}
                    size="sm"
                    variant="plain"
                    onChange={handleTabChange}
                />
            }
            compact
        >
            {meetings?.length > 0 &&
                <MeetingsList
                    learner={learner}
                    meetings={view === 'scheduled' ? scheduledMeetings : pastMeetings}
                    onAdd={meeting => setMeeting(meeting)}
                    onUpdate={onUpdate}
                    onDelete={onDelete}
                />
            }

            <FormDialog
                title="Новая регистрация"
                submitButtonText="Создать"
                open={Boolean(meeting)}
                onClose={() => setMeeting(null)}
            >
                <MeetingRegistrationForm
                    id="meeting-registration-form"
                    user={learner}
                    onSubmit={handleSubmit}
                />
            </FormDialog>
        </PageSection>
    );
}

export default function LearnerMeetings({ learner }) {
    const [meetings, actions] = useMeetings('published=true');

    const handleAddRegistration = useCallback((meeting, registration) => {
        return actions.addRegistration(meeting.id, registration);
    }, [actions]);

    const handleUpdateRegistration = useCallback((meeting, registration, data) => {
        return actions.updateRegistration(meeting.id, registration.id, data);
    }, [actions]);

    const handleRemoveRegistration = useCallback((meeting, registration) => {
        return actions.removeRegistration(meeting.id, registration.id);
    }, [actions]);

    return (
        <LearnerMeetingsView
            learner={learner}
            meetings={meetings}
            onCreate={handleAddRegistration}
            onUpdate={handleUpdateRegistration}
            onDelete={handleRemoveRegistration}
        />
    );
}